import React, { useState, useCallback } from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import StoreButton from './Forms/Store/StoreButton.js';

const useStyles = makeStyles({
  container: {
    textAlign: 'center',
    margin: '30px auto 0',
    width: 200
  }
});

const LoadMoreButton = (props) => {
  const { loadMore, loading } = props;
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();

  const handleClick = useCallback(async () => {
    setIsLoading(true);
    await loadMore();
    setIsLoading(false);
  }, [loadMore]);

  // this can be undefined e.g. if all the items have loaded
  // and there's no more to load
  if (!loadMore) {
    return null;
  }

  // `loading` (external) covers a load triggered another way — e.g. infinite scroll —
  // so the button still shows the spinner + disabled state during those, not just its own click.
  const showLoading = isLoading || !!loading;

  return (
    <div className={classes.container}>
      <StoreButton
        onClick={handleClick}
        loading={showLoading}
        disabled={showLoading}
        fullWidth
        label='Load More'
      />
    </div>
  );
};

LoadMoreButton.propTypes = {
  loadMore: PropTypes.func,
  loading: PropTypes.bool
};

export default LoadMoreButton;
